import React from "react";
import { Input } from "../Input/Input";

const EventDetails = ({ handleChange, sectionStyles, formData, errors }) => {
  // Define options for each radio group
  const childFriendlyOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
    { label: "Undecided", value: "undecided" },
  ];

  const timeOfDayOptions = [
    { label: "Morning", value: "morning" },
    { label: "Afternoon", value: "afternoon" },
    { label: "Flexible", value: "flexible" },
  ];

  const ceremonyTypeOptions = [
    { label: "Civil", value: "civil" },
    { label: "Symbolic", value: "symbolic" },
    { label: "Religious", value: "religious" },
  ];

  const venueTypeOptions = [
    { label: "Indoor", value: "indoor" },
    { label: "Outdoor", value: "outdoor" },
    { label: "Indoor/Outdoor", value: "indoorOutdoor" },
    { label: "No preference", value: "noPreference" },
  ];

  return (
    <section className={`p-3 mb-14 lg:mb-6 ${sectionStyles.alignSection}`}>
      <h2 className="text-2xl font-semibold">
        Basic <span className="uppercase">Event Details</span>
      </h2>

      <div className="space-y-6">
        {/* THE BIG DAY Section */}
        <h3 className="text-xl font-semibold uppercase mt-5">THE BIG DAY:</h3>
        <div className="lg:flex-row sm:justify-between items-center flex flex-col lg:gap-5">
          <Input
            title="Primary Date:"
            type="date"
            name="primaryDate"
            min={new Date().toISOString().split("T")[0]}
            value={formData.primaryDate || ""}
            handleChange={handleChange}
            sectionStyles={sectionStyles.label}
            // error={errors.primaryDate}
            divClassName="w-full"
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
          />
          <Input
            title="Alternative Dates (if any):"
            type="date"
            name="alternativeDates"
            min={new Date().toISOString().split("T")[0]}
            value={formData.alternativeDates || ""}
            handleChange={handleChange}
            sectionStyles={sectionStyles.label}
            divClassName="w-full"
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
          />
        </div>

        <Input
          title="Estimated number of guests:"
          type="number"
          name="estimatedGuests"
          value={formData.estimatedGuests || ""}
          handleChange={handleChange}
          sectionStyles={sectionStyles.label}
          // error={errors.estimatedGuests}
          className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
        />

        {/* Child-Friendly Wedding */}
        <div className="space-y-4 pt-4 flex items-center gap-4">
          
          <div className="flex items-center gap-4 flex-wrap flex-row md:flex-nowrap">
          <h4 className="text-lg font-semibold whitespace-nowrap">Child-Friendly Wedding:</h4>
            {childFriendlyOptions.map((option) => (
              <Input
                key={option.value}
                title={option.label}
                type="radio"
                name="childFriendly"
                value={option.value}
                checked={formData.childFriendly === option.value}
                handleChange={handleChange}
                sectionStyles={sectionStyles.label}
                className={sectionStyles.checkbox}
              />
            ))}
          </div>
        </div>
        {/* {errors.childFriendly && (
    <p className="text-red-500 text-sm">{errors.childFriendly}</p>
  )} */}

        {/* Time of Day */}
        <div className="space-y-4 pt-4 flex items-center gap-4">
          
          <div className="flex items-center gap-4 flex-wrap flex-row md:flex-nowrap">
          <h4 className="text-lg font-semibold whitespace-nowrap">Time of Day:</h4>
            {timeOfDayOptions.map((option) => (
              <Input
                key={option.value}
                title={option.label}
                type="radio"
                name="timeOfDay"
                value={option.value}
                checked={formData.timeOfDay === option.value}
                handleChange={handleChange}
                sectionStyles={sectionStyles.label}
                className={sectionStyles.checkbox}
              />
            ))}
          </div>
        </div>
        {/* {errors.timeOfDay && (
    <p className="text-red-500 text-sm">{errors.timeOfDay}</p>
        )} */}

        {/* Type of Ceremony */}
        <div className="space-y-4">
          <h4 className="text-lg font-semibold">Type of Ceremony:</h4>
          <div className="flex items-center gap-4 flex-wrap flex-row md:flex-nowrap">
            {ceremonyTypeOptions.map((option) => (
              <Input
                key={option.value}
                title={option.label}
                type="radio"
                name="ceremonyType"
                value={option.value}
                checked={formData.ceremonyType === option.value}
                handleChange={handleChange}
                sectionStyles={sectionStyles.label}
                className={sectionStyles.checkbox}
              />
            ))}
          </div>
          <Input
            title="Other:"
            type="text"
            name="ceremonyOther"
            value={formData.ceremonyOther || ""}
            handleChange={handleChange}
            sectionStyles={sectionStyles.label}
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black mt-2"
          />
        </div>
        {/* {(errors.ceremonyType || errors.ceremonyOther) && (
          <p className="text-red-500 text-sm">
            {errors.ceremonyType || errors.ceremonyOther}
          </p>
        )}
         */}

        {/* Preferred Location or Venue Type */}
        <div className="space-y-4 pt-4">
          <h4 className="text-lg font-semibold">Preferred Location or Venue Type:</h4>
          <div className="flex items-center gap-4 flex-wrap flex-row md:flex-nowrap">
            {venueTypeOptions.map((option) => (
              <Input
                key={option.value}
                title={option.label}
                type="radio"
                name="venueType"
                value={option.value}
                checked={formData.venueType === option.value}
                handleChange={handleChange}
                sectionStyles={sectionStyles.label}
                // error={errors.venueType}
                className={sectionStyles.checkbox}
              />
            ))}
          </div>
          {/* { errors.venueType && (
              <p className="text-red-500 text-sm">{errors.venueType}</p>
            )} */}
        </div>

        {/* Venue Details */}
        <div className="space-y-4 pt-4">
          <Input
            title="Have you identified a specific venue? If yes, please let us have details:"
            type="text"
            name="venueDetails"
            value={formData.venueDetails || ""}
            handleChange={handleChange}
            sectionStyles={sectionStyles.label}
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
          />
          <Input
            title="Venue Name:"
            type="text"
            name="venueName"
            value={formData.venueName || ""}
            handleChange={handleChange}
            sectionStyles={sectionStyles.label}
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
          />
          <Input
            title="Location:"
            type="text"
            name="venueLocation"
            value={formData.venueLocation || ""}
            handleChange={handleChange}
            sectionStyles={sectionStyles.label}
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
          />
        </div>
      </div>
    </section>
  );
};

export default EventDetails;
